import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getLatestTopics } from '@/lib/community';
import { PAGE_SIZE } from '@/lib/constants';
import TopicListCard from '@/components/feature/TopicListCard';
import Pagination from '@/components/feature/Pagination';

const latest = getLatestTopics();

export default function LatestTopics() {
  const [page, setPage] = useState(1);
  const totalPages = Math.ceil(latest.length / PAGE_SIZE);
  const pageItems = latest.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <section>
      <div className="flex items-end justify-between gap-4 mb-5">
        <div>
          <h2 className="text-xl md:text-2xl font-extrabold text-foreground-900">最新话题</h2>
          <p className="mt-1 text-sm text-foreground-500">刚刚有人在聊这些，快来看看</p>
        </div>
        <Link
          to="/search"
          className="hidden sm:inline-flex items-center gap-1 text-sm font-label font-bold text-primary-700 hover:text-primary-800 transition-colors cursor-pointer whitespace-nowrap"
        >
          发现更多
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="flex flex-col gap-3">
        {pageItems.map((topic) => (
          <TopicListCard key={topic.id} topic={topic} />
        ))}
      </div>

      <div className="mt-6">
        <Pagination page={page} totalPages={totalPages} onChange={setPage} />
      </div>
    </section>
  );
}